import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';

// material-ui
import { Link } from '@mui/material';

// project imports
import { DASHBOARD_PATH } from 'config';
import Logo from 'ui-component/Logo';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <Box sx={{ width: '228px', height: '38px', display: 'flex', justifyContent: 'center' }}>
        <Link component={RouterLink} to={DASHBOARD_PATH} aria-label="theme-logo">
            <Logo />
        </Link>
    </Box>
);

export default LogoSection;
